/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const contentAiPermissions = {
    "Contents_Create": "content-ai:contents:create",
    "Contents_SocialPublish": "content-ai:contents:social-publish",
    "Contents_FragmentDelivery": "content-ai:contents:fragment-delivery"
} as const;

export type PermissionsIdsDtoContentAiPermissionsEnum = (typeof contentAiPermissions)[keyof typeof contentAiPermissions];

export type PermissionsIdsDto = {
    /**
     * @description Available permissions for the content-ai provider
     * @type string
    */
    ContentAiPermissions: PermissionsIdsDtoContentAiPermissionsEnum;
};